/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

// actions + utils
import { updateAgent } from '../../../../actions/agent';
import { showPopup } from '../../../../utils/popup';

// components
import { LoaderButton } from '../../../../common/components';

const STATES = [
  'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL', 'GA',
  'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA',
  'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY',
  'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX',
  'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY',
];

function StateButton({ state, selectedStates, setSelectedStates }) {
  const selected = selectedStates.includes(state);

  function handleClick() {
    if (selected) {
      setSelectedStates(selectedStates.filter(s => s !== state));
    } else {
      setSelectedStates([ ...selectedStates, state ]);
    }
  }

  return (
    <button
      type="button"
      className={`btn m-1 ${selected ? 'btn-success' : 'btn-light'}`}
      style={{ width: '3rem' }}
      onClick={() => handleClick()}
    >
      {state}
    </button>
  );
}

function DisruptionAccess() {
  const [ selectedStates, setSelectedStates ] = useState([]);
  const [ loading, setLoading ] = useState(false);
  const {
    username,
    report_access: reportAccess = [],
  } = useSelector(store => store.agents.selectedAgent);

  function handleSave() {
    setLoading(true);
    updateAgent(username, { report_access: selectedStates })
      .then(() => showPopup('Updated successfully!', 'success'))
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    if ((reportAccess || []).length) setSelectedStates(reportAccess);
  }, [username]);

  return (
    <div>
      <div className="border border-light p-3 mb-4">
        <div className="row mb-3">
          <div className="col fs-3">
            States Available:
          </div>
        </div>

        <div className="row mb-3">
          <div className="col">
            {STATES.map(s => (
              <StateButton
                state={s}
                selectedStates={selectedStates}
                setSelectedStates={setSelectedStates}
                disabled={loading}
              />
            ))}
          </div>
        </div>

        <div className="row mb-3">
          <div className="col">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={() => setSelectedStates(STATES)}
              disabled={loading}
            >
              Select all
            </button>

            <button
              type="button"
              className="btn btn-outline-secondary ms-3"
              onClick={() => setSelectedStates([])}
              disabled={loading}
            >
              Unselect all
            </button>
          </div>
        </div>
      </div>

      <div>
        <LoaderButton
          type="button"
          className="btn btn-success"
          text="Update"
          loadingText="Updating"
          loading={loading}
          disabled={loading}
          onClick={() => handleSave()}
        />
      </div>
    </div>
  );
}

export default DisruptionAccess;
